
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { editSmsAccount } from '@/api/product/smsManage'

@Component({
  name: 'addAccount',
  components: {}
})
export default class extends Vue {
  @Prop() info!: any

  private infoForm: any = {
    account: this.info.account,
    password: this.info.password,
    status: this.info.status,
    price: this.info.price_str
  }

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }
  private back() {
    this.$emit('close', false)
  }

  private create() {
    ;(this.$refs.infoForm as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.flag = true
          let data = {
            id: this.info.id,
            ...this.infoForm
          }
          editSmsAccount(data).then(() => {
            this.$message({
              message: 'Edit successful!',
              type: 'success'
            })
            this.flagStr()
            this.back()
          })
        } catch (e) {
          this.flagStr()
        }
      } else {
        return false
      }
    })
  }

  mounted() {}
}
